import { TRAFFIC_SUB_VIEW_MODEL } from '../Model/Model';
import Dashboard from './SubComponents/Dashboard';
import ManageMainApp from './Functionality/ManageMainApp';
import Users from './SubComponents/Users';
import {permissionObj} from '../../../../Helpers/permission';
/**
 * @Email : sgarcia@ibl.mx
 * @Author: Susana Garcia Rodriguez
 * @jobTittle: Frontend
 */
const TrafficFines = (props) => {
    const {

        subView,
        setSubView,
        setModuleId,
        setOption,
        searchElement,
        setSearchElement,
        showFinesModal,
        setShowFinesModal,
        selectedInnerView,
        handleStepSelectedInnerView,
        setCriteria,
        setBodyForExport,
        setSearch
    } = props;

    const { DEV, permission, handleSubViewChange } = ManageMainApp({
        setSubView,
        setModuleId,
        setOption,
        setSearch,
        setSearchElement
    });
    return (
        <>
            { (subView === TRAFFIC_SUB_VIEW_MODEL.TRAFFIC_FINES.DASHBOARD  && (DEV || permission?.includes(permissionObj?.WEB_TRAFFIC_DASHBOARD_GEOFENCES_READ) || permission?.includes(permissionObj?.WEB_TRAFFIC_DASHBOARD_FINES_READ)) ) && (
                <Dashboard
                    subView={subView}
                    handleSubViewChange={handleSubViewChange}
                    searchElement={searchElement}
                    setSearchElement={setSearchElement}
                    showFinesModal={showFinesModal}
                    setShowFinesModal={setShowFinesModal}
                    selectedInnerView={selectedInnerView}
                    handleStepSelectedInnerView={handleStepSelectedInnerView}
                    setCriteria={setCriteria}
                    setBodyForExport={setBodyForExport}
                    setSearch={setSearch}
                />
            )}

            { (subView === TRAFFIC_SUB_VIEW_MODEL.TRAFFIC_FINES.USERS && ( DEV || permission?.includes(permissionObj?.WEB_TRAFFIC_USERS_READ) ) ) && (
                <Users
                    subView={subView}
                    handleSubViewChange={handleSubViewChange}
                    searchElement={searchElement}
                    setSearchElement={setSearchElement}
                    setBodyForExport={setBodyForExport}
                />
            )}
        </>
    );
};

export default TrafficFines;
